<template>
  <div class="page-content" style="margin: 0px auto 40px auto">
    <iframe-block :iframeId="'iframe'" v-if="loading"
                  :src="url"
    ></iframe-block>
  </div>
</template>

<script>
import AttachmentAttrDirective from "./AttachmentAttrDirective";
import IframeBlock from "./IframeBlock";
export default {
  name: "VannaAiHome",
  components:{
    IframeBlock
  },
  directives: {
    'attachment-attr': AttachmentAttrDirective
  },
  data() {
    return {
      message: null,
      loading: false,
      url: 'https://vanna-ai.retdata.com/',
    }
  },
  created() {
    this.init()
  },
  computed:{
  },
  methods: {
    init(){
      const type = this.$route.query.type
      if(type == 1){
        this.url= 'https://vanna-ai-demo2.retdata.com/'
        this.loading=true
      }else if(type == 2){
        this.url= 'https://vanna-ai.retdata.com/'
        this.loading=true
      }else {
        this.url= 'https://goai.retdata.com/chat/W8v4hQcTR6QYARMK'
        this.loading=true
      }
    }
  }
}
</script>

<style scoped>

</style>
